export default __webpack_public_path__ + "static/create-dashboard-036dc996dbf5b8f8424367b9a3bdcf91.png";